export const SECOND = 1000;
export const MINUTE = 60 * SECOND;
export const HOUR = 60 * MINUTE;
export const DAY = 24 * HOUR;

export type Countdown = {
	days: number;
	hours: number;
	minutes: number;
	seconds: number;
	done: boolean;
}

export type CountdownOptions = {
	/**
	 * The date and time being counted from. Usually the current date.
	 * Can be either a Date object or a numeric timestamp in milliseconds.
	 */
	from: Date | number;
	/**
	 * The target date and time being.
	 * Can be either a Date object or a numeric timestamp in milliseconds.
	 */
	to: Date | number;
}

/**
 * Returns the days, hours, minutes, and seconds from `from` to `to`.
 * If `from` is equal to or greater than `to`, then all of the above
 * will be `0`, and the returned Countdown's `done` property will be `true`
 */
export function getCountdown({ from, to }: CountdownOptions): Countdown {
	const timeDifference = +to - +from;

	if (timeDifference <= 0) {
		return {
			days: 0,
			hours: 0,
			minutes: 0,
			seconds: 0,
			done: true,
		};
	}

	return {
		days: Math.floor(timeDifference / DAY),
		hours: Math.floor((timeDifference % DAY) / HOUR),
		minutes: Math.floor((timeDifference % HOUR) / MINUTE),
		seconds: Math.floor((timeDifference % MINUTE) / SECOND),
		done: false,
	};
}